module.exports = __webpack_public_path__ + "static/studio-gear_800.34db80e7.jpg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/images/photos/studio-gear_800.jpg
// module id = 569
// module chunks = 0